import Cropper from 'cropperjs'

//   ####  #####     #####   #####
//  ##     ##  ##   ##   ##  ##  ##
//  ##     #####    ##   ##  #####
//  ##     ##  ##   ##   ##  ##
//   ####  ##   ##   #####   ##
/*
https://www.npmjs.com/package/cropperjs
https://fengyuanchen.github.io/cropperjs/
*/

const cropEdit = document.getElementById('imageCrop-crop') // エディター
const cropPreview = document.getElementById('imageCrop-view')
const cropData = document.getElementById('imageCrop-data')
const cropExt = document.getElementById('imageCrop-ext')
const cropMime = document.getElementById('imageCrop-mime')
const cropDlOrg = document.getElementById('cropImage-dl-org') // 元画像DL
const cropReset = document.getElementById('imageCrop-reset') // リセットボタン
const cropBrightness = document.getElementById('imageCrop-brightness') // 明るさ
const cropBrightnessClear = document.getElementById('imageCrop-brightness-clear') // 明るさ解除
const cropToggle = document.getElementById('imageCrop-toggle') // クロップOFF
const cropAlt = document.getElementById('imageCrop-alt') // Alt
const cropFinish = document.getElementById('imageCrop-finish') // 完了ボタン
const cropTarget = document.getElementById('imageCrop-target') // 適用先要素グループ名
const cropArea = document.getElementById('imageCrop-area') // 適用先要素グループ名
let cropper = null
const customFileReader = new FileReader()

//  ##   ##  #####   ##       #####     ###    ####
//  ##   ##  ##  ##  ##      ##   ##   ## ##   ##  ##
//  ##   ##  #####   ##      ##   ##  ##   ##  ##  ##
//  ##   ##  ##      ##      ##   ##  #######  ##  ##
//   #####   ##      ######   #####   ##   ##  ####

window.addEventListener('change', function (e) {
  const item = e.target.closest('.js-cropImage')
  if (!item) {
    return
  }
  fileSetup(item)
})
// 画像選択処理
function fileSetup(item) {
  // エラー判定
  let isError = false

  const target = item.dataset.target // 各種反映先のスラッグ
  const file = item.files[0]
  const fileName = file.name

  const fileSizeLimit = 3 // サイズ上限（MB）
  const sizeUnit = file.size > 1024 * 1024 ? 'MB' : 'KB' // 単位をMBかKBに分岐
  const fileSizeUnit = sizeUnit === 'MB' ? file.size / (1024 * 1024) : file.size / 1024 // 単位に合わせて補正したファイルサイズ
  const fileSizeView = fileSizeUnit.toFixed(2) + sizeUnit // ファイルサイズ出力テキスト

  let getExt = checkExt(fileName, '.jpg,.jpeg,.png,.gif,.avif') // 拡張取得
  if (!getExt) {
    // 無効な拡張子は弾く
    window.popToast('対応する画像形式ではありません。')
    return
  }

  // サイズバリデーション
  if (file.size > fileSizeLimit * 1024 * 1024) {
    window.popToast('ファイルサイズは' + fileSizeLimit + 'MB以下にしてください (' + fileSizeView + ')。')
    return
  }

  // 拡張子からMIMEタイプを求める
  // GIFはPNGに変換されるので補正する
  getExt = getExt === 'gif' ? 'png' : getExt
  let getMime
  if (getExt === 'png') {
    getMime = 'image/png'
  } else {
    getMime = 'image/jpeg'
  }

  // ファイル名を送信させる
  const fineNameTarget = document.getElementById('js-customFile-name--' + target)
  if (fineNameTarget) {
    if (!isError) {
      fineNameTarget.value = file.name
    } else {
      fineNameTarget.value = ''
    }
  }

  // 画像の仮アップ
  preUpload(file, target, fileName, isError)

  // 切り替わる要素を反映させる
  const fileDelTarget = document.getElementsByClassName('js-customFile-toggle--' + target)
  if (fileDelTarget[0]) {
    if (!isError) {
      for (const iterator of fileDelTarget) {
        iterator.classList.add('active')
      }
    } else {
      for (const iterator of fineDelTarget) {
        iterator.classList.remove('active')
      }
    }
  }

  // const reader = new FileReader()
  // reader.onload = () => {
  //   window.modalOpen('crop') // 非表示解除

  //   console.log(reader.result)
  //   cropEdit.src = reader.result
  //   if (cropper) {
  //     cropper.destroy()
  //     cropper = null
  //   }
  //   crop(getExt, getMime)
  // }
  // reader.readAsDataURL(file)
}

//   #####   #####   #####  ##     ##
//  ##   ##  ##  ##  ##     ####   ##
//  ##   ##  #####   #####  ##  ## ##
//  ##   ##  ##      ##     ##    ###
//   #####   ##      #####  ##     ##

window.addEventListener('click', function (e) {
  const btn = e.target.closest('.js-imageCrop-start')
  if (!btn) {
    return
  }
  const target = btn.dataset.target
  cropSetup(target)
})

// クロップ展開処理
function cropSetup(target) {
  window.modalOpen('crop') // 非表示解除
  const imgOrgData = document.getElementById('js-customFile-org--' + target).value

  cropDlOrg.href = imgOrgData
  cropDlOrg.download = document.getElementById('js-customFile-name--' + target).value

  cropBrightness.value = parseInt(document.getElementById('js-customFile-brightness--' + target).value, 10) - 100
  cropAlt.value = document.getElementById('js-customFile-alt--' + target).value
  cropTarget.value = target

  cropArea.value = document.getElementById('js-customFile-crop--' + target).value

  cropEdit.src = imgOrgData
  if (cropper) {
    cropper.destroy()
    cropper = null
  }
  crop()
  // crop(getExt, getMime)
}

function crop(ext = '', mime = '') {
  /* global Cropper */

  cropper = new Cropper(cropEdit, {
    // aspectRatio: 3 / 3, // クロップ比率
    autoCrop: true, // 最初からクロップ枠を出す
    autoCropArea: 1, // 初期クロップ枠のサイズ倍率
    movable: false, // 画像を動かせる
    rotatable: false, // 画像を回せる
    scalable: false, // サイズ変更
    zoomable: false, // 拡縮
    ready(event) {
      loadCropArea() // クロップ範囲を復元
      setBrightness() //明るさを反映
      applyCrop() // 結果を反映
    },
    crop(event) {},
    cropend(event) {
      applyCrop() // 結果を反映
    },
  })
  cropReset.addEventListener('click', function (e) {
    cropper.reset()
    applyCrop() // 結果を反映
    cropBrightness.value = 0
    setBrightness() //明るさを反映
  })

  // 前回のクロップ範囲を復元
  function loadCropArea() {
    if (cropArea.value === '') {
      // データがなければ省略
      return
    }

    const data = JSON.parse(cropArea.value)
    cropper.setCropBoxData({
      width: data['width'],
      height: data['height'],
      top: data['top'],
      left: data['left'],
    })
  }

  function applyCrop() {
    cropData.value = cropper.getCroppedCanvas().toDataURL(mime)
    cropMime.value = mime
    cropExt.value = ext
    cropPreview.src = cropper.getCroppedCanvas().toDataURL(mime)

    const nowCrop = cropper.getCropBoxData()
    // console.log(nowCrop)

    cropArea.value = JSON.stringify(nowCrop)
  }

  //   ####  #####     #####   #####
  //  ##     ##  ##   ##   ##  ##  ##
  //  ##     #####    ##   ##  #####
  //  ##     ##  ##   ##   ##  ##
  //   ####  ##   ##   #####   ##
  // クロップエリアを画像の半分の形状で配置
  cropToggle.addEventListener('click', function (e) {
    const imageData = cropper.getImageData()
    cropper.setCropBoxData({
      width: imageData['width'] / 2,
      height: imageData['height'] / 2,
      top: imageData['height'] / 4,
      left: imageData['width'] / 4,
    })
    applyCrop() // 結果を反映
  })

  //  #####   #####    ##   ####    ##   ##  ######
  //  ##  ##  ##  ##   ##  ##       ##   ##    ##
  //  #####   #####    ##  ##  ###  #######    ##
  //  ##  ##  ##  ##   ##  ##   ##  ##   ##    ##
  //  #####   ##   ##  ##   ####    ##   ##    ##

  cropBrightness.addEventListener('input', function (e) {
    setBrightness() //明るさを反映
  })
  cropBrightnessClear.addEventListener('click', function (e) {
    // 明るさリセットボタン
    cropBrightness.value = 0
    setBrightness() //明るさを反映
  })
}

//   ####    ###    ##   ##  #####
//  ##      ## ##   ##   ##  ##
//   ###   ##   ##  ##   ##  #####
//     ##  #######   ## ##   ##
//  ####   ##   ##    ###    #####

cropFinish.addEventListener('click', function (e) {
  saveCrop()
})
function setBrightness() {
  const targetImg = document.querySelector('.cropper-bg')
  const targetValue = document.getElementById('imageCrop-bright')
  const value = parseInt(cropBrightness.value, 10) + 100

  targetImg.style.filter = 'brightness(' + value + '%)'
  targetValue.value = +value
}

function saveCrop() {
  // 編集結果を反映する
  const target = cropTarget.value

  // 各種データ反映
  document.querySelector('.js-customFile-cropData--' + target).value = cropData.value
  document.getElementById('js-customFile-alt--' + target).value = cropAlt.value
  const brightness = parseInt(cropBrightness.value, 10) + 100
  document.getElementById('js-customFile-brightness--' + target).value = brightness
  document.getElementById('js-customFile-crop--' + target).value = cropArea.value

  window.inputSync(document.getElementById('js-customFile-alt--' + target)) // Altを他の入力欄と同期

  const croppedData = cropper.getData(true) // 実際の画像サイズ基準のデータを取得
  const cropRealJson =
    '{"left":' +
    croppedData.x +
    ',"top":' +
    croppedData.y +
    ',"width":' +
    croppedData.width +
    ',"height":' +
    croppedData.height +
    '}'

  cropUpload(target, cropRealJson, brightness)
}

//  ####    #####  ##
//  ##  ##  ##     ##
//  ##  ##  #####  ##
//  ##  ##  ##     ##
//  ####    #####  ######

window.addEventListener('click', function (e) {
  fileUpDel(e.target)
})
function fileUpDel(item) {
  if (!item.classList.contains('js-customFile-del')) {
    return
  }

  const confirm = window.confirm('画像を削除してよろしいですか？')
  if (!confirm) {
    return
  }

  const target = item.dataset.target // 各種反映先のスラッグ

  // ファイルを消す
  console.log('js-customFile--' + target)
  document.getElementById('js-customFile--' + target).value = ''

  // 送信するvalueを消す
  const valueList = document.getElementsByClassName('js-customFile-del-value--' + target)
  for (const iterator of valueList) {
    iterator.value = ''
  }

  // 切り替わる要素を消す
  const fileDelTarget = document.getElementsByClassName('js-customFile-toggle--' + target)
  if (fileDelTarget[0]) {
    for (const iterator of fileDelTarget) {
      iterator.classList.remove('active')
    }
  }
  // プレビューを消す
  const previewDelTarget = document.getElementsByClassName('js-customFile-preview--' + target)
  if (previewDelTarget[0]) {
    for (const iterator of previewDelTarget) {
      iterator.src = ''
    }
  }

  // テキスト表示欄をリセットする
  const fileTextTarget = document.getElementsByClassName('js-customFile-out--' + target)
  for (let index = 0; index < fileTextTarget.length; index++) {
    fileTextTarget[index].innerHTML = fileTextTarget[index].dataset.def
  }
}

// 文字列から拡張子を返す
function getExt(fileName) {
  var pos = fileName.lastIndexOf('.')
  if (pos === -1) return ''
  return fileName.slice(pos + 1)
}
// 拡張子を検証する
function checkExt(fileName, exts) {
  //比較のため小文字にする
  var ext = getExt(fileName).toLowerCase()
  //許可する拡張子の一覧(allow_exts)から対象の拡張子があるか確認する
  if (exts.indexOf(ext) === -1) {
    return false
  }
  return ext
}

//  #####   #####    #####
//  ##  ##  ##  ##   ##
//  #####   #####    #####
//  ##      ##  ##   ##
//  ##      ##   ##  #####
// 仮アップロードして画像URLを取得する
function preUpload(file, target, fileName, isError) {
  /* global uploadUrl */
  if (!file || isError) {
    setUrl('', target, '', true)
    return
  }

  const formData = new FormData()
  formData.append('file', file) // ファイルをセット

  const filePreNameArea = document.getElementById('js-customFile-pre-name--' + target)
  formData.append('old', filePreNameArea.value) // アップ済みの仮ファイル名をセット

  const label = document.querySelector('label[for="js-customFile--' + target + '"].md-btn')

  label.innerText = '仮アップロード中...'

  fetch(uploadUrl + 'pre-upload.php', {
    method: 'POST',
    body: formData,
  })
    .then((response) => {
      if (!response.ok) throw new Error('Upload failed')

      return response.text() // テキストとして取得
    })
    .then((url) => {
      console.log(url)

      setUrl(url, target, fileName, isError)
      label.innerText = 'ファイルを選択'
    })
    .catch((error) => {
      console.error('Upload error:', error)

      label.innerText = '仮アップロード失敗'

      setTimeout(() => {
        label.innerText = 'ファイルを選択'
      }, 3000)
    })
}

//  ##   ##  #####    ##
//  ##   ##  ##  ##   ##
//  ##   ##  #####    ##
//  ##   ##  ##  ##   ##
//   #####   ##   ##  ######
function setUrl(url, target, fileName, isError) {
  // const url = customFileReader.result
  // const url = URL.createObjectURL(file)

  let isReadFile = false
  // BASE64版のデータをセットする
  const fineBase64Target = document.getElementsByClassName('js-customFile-base64--' + target)

  if (fineBase64Target[0]) {
    if (!isError) {
      cropDlOrg.href = url
      cropDlOrg.download = fileName
      for (const iterator of fineBase64Target) {
        iterator.value = url
      }
      isReadFile = true
    } else {
      cropDlOrg.href = ''
      cropDlOrg.download = ''
      for (const iterator of fineBase64Target) {
        iterator.value = ''
      }
    }
  }

  // 画像ファイルをプレビューさせる
  const finePreviewTarget = document.getElementsByClassName('js-customFile-preview--' + target)

  if (finePreviewTarget[0]) {
    if (!isError) {
      for (const iterator of finePreviewTarget) {
        iterator.src = url
      }
      isReadFile = true
    } else {
      for (const iterator of finePreviewTarget) {
        iterator.src = ''
      }
    }
  }

  // 仮ファイル名をセットする
  const filePreNameArea = document.getElementById('js-customFile-pre-name--' + target)

  const filePreName = url2fileName(url)
  // console.log(filePreName)

  if (finePreviewTarget[0]) {
    if (!isError) {
      filePreNameArea.value = filePreName
    } else {
      filePreNameArea.value = ''
    }
  }
}

//   ####  #####     #####   #####
//  ##     ##  ##   ##   ##  ##  ##
//  ##     #####    ##   ##  #####
//  ##     ##  ##   ##   ##  ##
//   ####  ##   ##   #####   ##

function cropUpload(target, cropData, brightness) {
  /* global uploadUrl */
  const formData = new FormData()

  const filePreNameArea = document.getElementById('js-customFile-pre-name--' + target)
  formData.append('pre_file_name', filePreNameArea.value) // アップ済みの仮ファイル名をセット

  // console.log('orgImg')

  // console.log('https://stg-spc.net/projects/ibanavi/_img/pre-uploads/' + filePreNameArea.value)

  formData.append('crop', cropData)

  const label = document.querySelector('label[for="js-customFile--' + target + '"].md-btn')

  label.innerText = '加工中...'

  fetch(uploadUrl + 'crop.php', {
    method: 'POST',
    body: formData,
  })
    .then((response) => {
      if (!response.ok) throw new Error('Upload failed')

      return response.text() // テキストとして取得
    })
    .then((url) => {
      console.log(url)

      setCrop(target, url, brightness)

      label.innerText = 'ファイルを選択'
    })
    .catch((error) => {
      console.error('Upload error:', error)

      label.innerText = '加工失敗'

      setTimeout(() => {
        label.innerText = 'ファイルを選択'
      }, 3000)
    })
}

function setCrop(target, url, brightness) {
  // プレビュー画像更新
  const preview = document.querySelector('.js-customFile-preview--' + target)
  preview.src = url
  preview.style.filter = 'brightness(' + brightness + '%)'

  // 仮ファイル名をセットする
  const filePreNameArea = document.getElementById('js-customFile-pre-name--' + target)

  console.log('cropFile')

  const filePreName = url2fileName(url).replace(/^crop-/, '')
  console.log(filePreName)

  filePreNameArea.value = filePreName
}

//  #####  ##  ##      #####
//  ##     ##  ##      ##
//  #####  ##  ##      #####
//  ##     ##  ##      ##
//  ##     ##  ######  #####
// URLからファイル名を抽出
function url2fileName(url) {
  return url
    .substring(url.lastIndexOf('/') + 1)
    .split('?')[0]
    .split('#')[0]
}
